import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./plugins/element.js";
import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import Axios from "axios";
import VueAxios from "vue-axios";
import api from "./http/api";
import http from "./http/http";
import _ from 'lodash'
Vue.prototype.$_ = _
// import BaiduMap from "vue-baidu-map";
import qs from "qs";
import Print from 'vue-print-nb'
Vue.use(Print); //注册
import Fragment from 'vue-fragment'
Vue.use(Fragment.Plugin)

//gis css
import "./assets/css/gis.css";

import {auth} from './directive/auth.js'
Vue.use(auth) 
// 把bus挂载到了Vue的原型上, 保证所有的组件都能通过 this.$bus访问到事件总线
Vue.prototype.$bus = new Vue()
 

// 视频组件
// import EasyPlayer from '@easydarwin/easyplayer'
// Vue.component('EasyPlayer', EasyPlayer)
import "babel-polyfill"; //解决低版本浏览器不显示问题

import dayjs from "dayjs"
Vue.prototype.$dayjs = dayjs;
// 富文本编辑器
import 'ant-design-vue/dist/antd.css'
import {
  Menu,
  Input,
  Popover,
  Button,
  Icon,
  Table,
  Empty,
  ConfigProvider,
  Calendar,
  Progress,
  Tree
} from 'ant-design-vue'
 
// 全局注册组件
import comtables from './components/index.js';
import ECharts from 'vue-echarts'
import 'echarts' // 去掉这个会没有动态效果
Vue.component('v-chart', ECharts)

// const myicon = Icon.createFromIconfontCN({
//   scriptUrl: '//at.alicdn.com/t/font_2758247_txkr2hl98b.js'
// })
// //引用
// Vue.component('my-icon', myicon)

// echarts
Vue.use(ConfigProvider)
Vue.use(Empty)
Vue.use(Table)
Vue.use(Calendar)
Vue.use(Progress)
Vue.use(Tree)
Vue.use(Menu)
Vue.use(Icon)
Vue.use(Button)
Vue.use(Input)
Vue.use(Popover)
Vue.use(comtables) 
// import moment from 'moment'
//引入axios请求
Vue.use(VueAxios, Axios);
// 引入element组件库
Vue.use(Element);
// // 图标css
import "./assets/iconfont/iconfont.css";
import "./assets/iconfont/iconfont.js";
// //公用css
import "./assets/css/common.css";
import "./assets/css/base.scss";
// // axios 拦截器
import "./http/axios";
// 全局挂载qs进行序列化数据
// 注册全局变量
import global_ from './components/Global.vue' //引用文件
Vue.prototype.GLOBAL = global_ //挂载到Vue实例上面
import Tools from "../utils/tool.js";
Vue.prototype.Tools = Tools //挂载到Vue实例上面

Vue.prototype.$qs = qs;
// Vue.prototype.$moment = moment;
Vue.prototype.$api = api;
Vue.prototype.$axios = http;
// Vue.use(BaiduMap, {
//   // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
//   ak: "DD279b2a90afdf0ae7a3796787a0742e",
// });
Vue.config.productionTip = false;
 
router.beforeEach((to, from, next) => {
   
  if (to.meta.requireLogin) {
      if (sessionStorage.getItem("tokenData")) {
        if (to.path === "/login") {
          next();
        } else {
          if (checkRoutePermission(to, JSON.parse(sessionStorage.getItem("permission")))) {
            next();
          } else {
            // alert("")
            Vue.prototype.$message({
              message: "没有权限",
              type: "error",
            });
          }
        }
      } else {
        if (to.path === "/login") {
          next();
        } else {
          next({
            path: "/login",
          });
        }
      }
  } else {
    next();
  }
});
function getUrlKey(name) {    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null}
function loginIndex(res) {
  let routers = router.options.routes;
  let permission = ["a", "b"]; 
  let arrMenu = routers.filter((item) => {
    if (item.meta && item.noDropdown) {
      if (checkRoutePermission(item, permission)) {
        return item;
      }
    }
  });
  // 暂时自己写的权限
  sessionStorage.setItem("permission", JSON.stringify(permission));
  sessionStorage.setItem("getMenuList", JSON.stringify(arrMenu));
  sessionStorage.setItem(
    "tokenData",
    JSON.stringify(res.data.data.token)
  );
  sessionStorage.setItem(
    "appAuths",
    JSON.stringify(res.data.data.appAuths)
  );
  sessionStorage.setItem(
    "userName",
    JSON.stringify(res.data.data.userName)
  );
  // this.$router.push("/essentialInformation");
}

function checkRoutePermission(to, permissionList) {
    
  var isValidate = false;
  if (to.meta.permissionPath) {
    isValidate = to.meta.permissionPath.some((item) =>
      permissionList.includes(item)
    );
  }
  return isValidate;
}
var vue = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

// export default vue 